import { type CollabInfrastructure } from '@canvas/document-id';

import { CfCollabStrategy } from './cf-collab-strategy.ts';
import { type CollabStrategy } from './collab-strategy.ts';
import { NcsCollabStrategy } from './ncs-collab-strategy.ts';

export function getCollabStrategy(
  collabInfrastructure: CollabInfrastructure,
): CollabStrategy {
  switch (collabInfrastructure) {
    case 'ncs':
      return new NcsCollabStrategy();
    case 'cf':
    default:
      return new CfCollabStrategy();
  }
}
